let prefix = '/api/user_indicators';

function getID(id){
    return window.axios.get(prefix+'/getIndiId/'+id);
}
function getIDNot(id){
    return window.axios.get(prefix+'/getIndiNotId/'+id);
}
function store(data){
    return window.axios.post(prefix+'/store', data);
}
function deleteUserIndi(id){
    return window.axios.delete(prefix+'/'+id);
}

export default {
    getID,
    store,
    getIDNot,
    deleteUserIndi,
}